var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/calendar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,5.8 C4,5.03 4.6,4.4 5.33333333,4.4 L14.6666667,4.4 C15.4030463,4.4 16,5.02680135 16,5.8 L16,15.6 C16,16.3731986 15.4030463,17 14.6666667,17 L5.33333333,17 C4.59695367,17 4,16.3731986 4,15.6 L4,5.8 Z M5.33333333,7.2 L5.33333333,15.6 L14.6666667,15.6 L14.6666667,7.2 L5.33333333,7.2 Z M6.66666667,3 L8,3 L8,4.4 L6.66666667,4.4 L6.66666667,3 Z M12,3 L13.3333333,3 L13.3333333,4.4 L12,4.4 L12,3 Z M6.66666667,9.3 L8,9.3 L8,10.7 L6.66666667,10.7 L6.66666667,9.3 Z M6.66666667,12.1 L8,12.1 L8,13.5 L6.66666667,13.5 L6.66666667,12.1 Z M9.33333333,9.3 L10.6666667,9.3 L10.6666667,10.7 L9.33333333,10.7 L9.33333333,9.3 Z M9.33333333,12.1 L10.6666667,12.1 L10.6666667,13.5 L9.33333333,13.5 L9.33333333,12.1 Z M12,9.3 L13.3333333,9.3 L13.3333333,10.7 L12,10.7 L12,9.3 Z M12,12.1 L13.3333333,12.1 L13.3333333,13.5 L12,13.5 L12,12.1 Z",
    id: "icon",
    fill: "#636F77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d126b455.svg";
export { ForwardRef as ReactComponent };